module.exports = __webpack_public_path__ + "static/media/home.846f048d.png";